import { useState, useEffect } from 'react'

export function useCmsPage(slug) {
  const [page, setPage] = useState(null)
  const [loading, setLoading] = useState(true)
  const [error, setError] = useState(null)

  useEffect(() => {
    let isMounted = true

    async function fetchPage() {
      try {
        setLoading(true)
        // Try public by-slug endpoint
        const res = await fetch(`https://api.dev.auxo.dk/public/by-slug/${slug}`)
        if (res.ok) {
          const data = await res.json()
          if (isMounted) {
            setPage(data)
            setLoading(false)
            return
          }
        }

        // Fallback: search in v2 pages collection
        const listRes = await fetch(`https://api.dev.auxo.dk/public/v2/content/pages?limit=25`)
        if (listRes.ok) {
          const listData = await listRes.json()
          const matched = listData.items?.find((p) => {
            const s = typeof p.slug === 'object' ? p.slug?._ : p.slug
            return s === slug
          })
          if (isMounted && matched) {
            setPage(matched)
          }
        }
      } catch (err) {
        if (isMounted) setError(err)
      } finally {
        if (isMounted) setLoading(false)
      }
    }

    fetchPage()

    return () => {
      isMounted = false
    }
  }, [slug])

  return { page, loading, error }
}
